import axios from 'axios'

const showCategoriesCards = async (categoryId) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}api/viewCardsCategoryForClient/${categoryId}`,
      {
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )

    return response.data.data
  } catch (error) {
    throw error
  }
}

export default showCategoriesCards
